import { render, staticRenderFns } from "./SystemBanner.vue?vue&type=template&id=5dcbf153&scoped=true"
import script from "./SystemBanner.vue?vue&type=script&lang=js"
export * from "./SystemBanner.vue?vue&type=script&lang=js"
import style0 from "./SystemBanner.vue?vue&type=style&index=0&id=5dcbf153&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbf153",
  null
  
)

export default component.exports